import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Result, Button } from 'antd';

const NotFoundPage = ({ authentication }) => {
  if (authentication.productLogin?.isInProgress) {
    return <div>...</div>;
  }

  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist or you do not have access to this page. Please contact your administrator."
      extra={
        <Button type="primary" href="/app">
          Back Home
        </Button>
      }
    />
  );
};

NotFoundPage.propTypes = {
  authentication: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication
  };
};

export default connect(mapStateToProps)(NotFoundPage);
